import { all, fork } from "redux-saga/effects";
import authSaga from "./auth/auth.saga";
import meSaga from "./me/me.saga";
import usersSaga from "./users/users.saga";
import firstPasswordChangeSaga from "./firstPasswordChange/firstPasswordChange.saga";
import userSaga from "./user/user.saga";
import fieldsTypeSaga from "./fieldsType/fieldsType.saga";
import fieldTypeSaga from "./fieldType/fieldType.saga";
import cropsSaga from "./crops/crops.saga";
import cultureSaga from "./culture/culture.saga";
import irrigationTypesSaga from "./irrigationTypes/irrigationTypes.saga";
import irrigationTypeSaga from "./irrigationType/irrigationType.saga";
import fieldsSaga from "./customer/fields/fields.saga";
import fieldSaga from "./customer/field/field.saga";
import instrumentsSaga from "./customer/instruments/instruments.saga";
import sensorSaga from "./customer/sensor/sensor.saga";
import gatewaysSaga from "./customer/instruments/gateways.saga";
import gatewaySaga from "./customer/gateway/gateway.saga";
import sensorTypesSaga from "./customer/sensorTypes/sensorTypes.saga";
import updateFrequenciesSaga from "./customer/updateFrequencies/updateFrequencies.saga";
import sensorsSaga from "./customer/instruments/sensors.saga";
import weatherSaga from "./weather/weather.saga";
import sensorDataSaga from "./customer/sensor/sensorData.saga";
import sensorAverageDataSaga from "./customer/sensor/sensorAverageData.saga";
import roverDataSaga from "./customer/roverData/sensorData.saga";
import resetPasswordSaga from "./resetPassword/resetPassword.saga";
import resetPasswordRequestSaga from "./resetPassword/resetPasswordRequest.saga";
import changePasswordSaga from "./changePassword/changePassword.saga";
import fieldNotesSaga from "./fieldNotes/fieldNotes.saga";
import fieldNoteSaga from "./fieldNote/fieldNote.saga";
import diseasesSaga from "./diseases/diseases.saga";
import diseaseStatusSaga from "./customer/diseaseStatus/diseaseStatus.saga";
import dTFieldsSaga from "./digitalTwin/dTFields.saga";
import plantsSaga from "./digitalTwin/plants.saga";
import digitalTwinSaga from "./digitalTwin/digitalTwin.saga";
import plantsMeasurementsSaga from "./digitalTwin/plantsMeasurements.saga";
import rastersSaga from "./digitalTwin/rasters.saga";
import fieldImagesSaga from "./digitalTwin/fieldImages.saga";
import plantDigitalTwinSaga from "./digitalTwin/plantDigitalTwin.saga";
import farmsSaga from "./digitalTwin/farms/farms.saga";
import sensorHeatmapSaga from "./customer/sensorHeatmap/sensorHeatmap.saga";
import diseaseRiskSaga from "./customer/diseaseRisk/diseaseRisk.saga";

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(meSaga),
    fork(usersSaga),
    fork(firstPasswordChangeSaga),
    fork(userSaga),
    fork(fieldsTypeSaga),
    fork(fieldTypeSaga),
    fork(cropsSaga),
    fork(cultureSaga),
    fork(irrigationTypesSaga),
    fork(irrigationTypeSaga),
    fork(fieldsSaga),
    fork(fieldSaga),
    fork(instrumentsSaga),
    fork(sensorSaga),
    fork(gatewaysSaga),
    fork(gatewaySaga),
    fork(sensorTypesSaga),
    fork(updateFrequenciesSaga),
    fork(sensorsSaga),
    fork(weatherSaga),
    fork(sensorDataSaga),
    fork(sensorAverageDataSaga),
    fork(roverDataSaga),
    fork(resetPasswordSaga),
    fork(resetPasswordRequestSaga),
    fork(changePasswordSaga),
    fork(fieldNotesSaga),
    fork(fieldNoteSaga),
    fork(diseasesSaga),
    fork(diseaseStatusSaga),
    /* digital twin data */
    fork(dTFieldsSaga),
    fork(plantsSaga),
    fork(digitalTwinSaga),
    fork(plantsMeasurementsSaga),
    fork(rastersSaga),
    fork(fieldImagesSaga),
    fork(plantDigitalTwinSaga),
    fork(farmsSaga),
    fork(sensorHeatmapSaga),
    fork(diseaseRiskSaga),
  ]);
}
